<template>
    <div>
        <v-alert v-if="mostrar" :type="configuracion.tipo">
            {{configuracion.mensaje}}
        </v-alert>
    </div>
</template>
<script>
export default {
    data:()=>({
        configuracion:{},
        mostrar:false
    }),
    beforeDestroy() {
        Event.$off('mostrar_alert');
    },
    mounted() {
        Event.$on('mostrar_alert',(conf)=>{
            this.configuracion = conf;
            this.mostrar = true;
        });
    },
}
</script>